import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/app/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import DropDown from './';
import ThemeProvider from '../Theme/ThemeProvider';
import Flex from '../Layout/Flex';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "dropdown"
    }}>{`DropDown`}</h1>
    <p>{`This is a general purpose collapsible dropdown (use it for dropdown list box (select), navigation drop down list...)`}</p>
    <h2 {...{
      "id": "default-props"
    }}>{`Default props`}</h2>
    <Playground __position={0} __code={'<ThemeProvider>\n  <DropDown />\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      DropDown,
      ThemeProvider,
      Flex,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
          <DropDown mdxType="DropDown" />
  </ThemeProvider>
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <ThemeProvider mdxType="ThemeProvider">
  <Props of={DropDown} mdxType="Props" />
    </ThemeProvider>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={2} __code={'<ThemeProvider>\n  <DropDown\n    box={<div>Box content</div>}\n    trigger={<div>trigger content</div>}\n  />\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      DropDown,
      ThemeProvider,
      Flex,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <DropDown box={<div>Box content</div>} trigger={<div>trigger content</div>} mdxType="DropDown" />
  </ThemeProvider>
    </Playground>
    <h2 {...{
      "id": "inline"
    }}>{`Inline`}</h2>
    <Playground __position={3} __code={'<ThemeProvider>\n  <div>\n    <p>Lorem ipsum</p>\n    <DropDown inline={true} trigger={<div>Click me</div>} box={\'Foo\'} />\n    <p>Lorem ipsum</p>\n  </div>\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      DropDown,
      ThemeProvider,
      Flex,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <div>
      <p>Lorem ipsum</p>
      <DropDown inline={true} trigger={<div>Click me</div>} box={'Foo'} mdxType="DropDown" />
      <p>Lorem ipsum</p>
    </div>
  </ThemeProvider>
    </Playground>
    <h2 {...{
      "id": "anchor"
    }}>{`Anchor`}</h2>
    <p>{`not applicable when using `}<inlineCode parentName="p">{`inline`}</inlineCode></p>
    <Playground __position={4} __code={'<ThemeProvider>\n  <Flex style={{ justifyContent: \'space-between\' }}>\n    <p>Lorem ipsum</p>\n    <DropDown anchor={\'left\'} trigger={<div>Click me</div>} box={\'foobar\'} />\n    <p>Lorem ipsum</p>\n    <DropDown anchor={\'right\'} trigger={<div>Click me</div>} box={\'foobar\'} />\n    <p>Lorem ipsum</p>\n  </Flex>\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      DropDown,
      ThemeProvider,
      Flex,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <Flex style={{
          justifyContent: 'space-between'
        }} mdxType="Flex">
      <p>Lorem ipsum</p>
      <DropDown anchor={'left'} trigger={<div>Click me</div>} box={'foobar'} mdxType="DropDown" />
      <p>Lorem ipsum</p>
      <DropDown anchor={'right'} trigger={<div>Click me</div>} box={'foobar'} mdxType="DropDown" />
      <p>Lorem ipsum</p>
    </Flex>
  </ThemeProvider>
    </Playground>
    {
      /* ## Controlled
      <Playground>
       <WithState>
         {
           (state, setState) => (
               <div>
                 <DropDown
                   inline
                   open={state}
                   onChange={(a) => {
                     console.log('onChange onsumer a', a)
                     setState(a)
                   }}
                   trigger={<div>Click me <span>({state ? 'open' : 'closed'})</span></div>}
                   box={'whatever'}
                 />
                 <br/>
                 <button onClick={() => setState(!state)} >Toggle programmatically</button>
               </div>
              )
         }
       </WithState>
      </Playground> */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      